// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-resource-resource_id.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm($id: uuid!, $resource_id: uuid!) {
  update_tasks_resources_by_pk(
    pk_columns: { id: $id }
    _set: { resource_id: $resource_id }
  ) {
    id
  }
}

`